// whatsapp-automatic-history-sync.RECOVERY.5
// Install the listener before login: FINISH and the authorization code can arrive in either order.
export function freshCoexistenceSignup(configId) {
  return new Promise((resolve, reject) => {
    let code;
    let business;
    let listener;
    let timeout;
    function cleanup() {
      clearTimeout(timeout);
      window.removeEventListener('message', listener);
    }

    const finish = () => {
      if (!code || !business) return;
      cleanup();
      resolve({ ...business, code, is_business_app_onboarding: true });
    };
    const fail = () => {
      cleanup();
      reject(new Error('Fresh coexistence signup was not completed'));
    };
    listener = event => {
      if (
        ![
          'https://www.facebook.com',
          'https://web.facebook.com',
          'https://business.facebook.com',
          'https://facebook.com',
        ].includes(event.origin)
      )
        return;
      let data;
      try {
        data =
          typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      } catch {
        return;
      }
      if (data?.type !== 'WA_EMBEDDED_SIGNUP') return;
      if (['CANCEL', 'ERROR', 'error'].includes(data.event)) {
        fail();
        return;
      }
      if (data.event !== 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING') return;
      if (!data.data?.waba_id || !data.data?.phone_number_id) {
        fail();
        return;
      }
      business = {
        waba_id: data.data.waba_id,
        phone_number_id: data.data.phone_number_id,
      };
      finish();
    };
    timeout = setTimeout(fail, 5 * 60 * 1000);
    window.addEventListener('message', listener);
    try {
      window.FB.login(
        response => {
          code = response.authResponse?.code;
          if (!code) {
            fail();
            return;
          }
          finish();
        },
        {
          config_id: configId,
          response_type: 'code',
          override_default_response_type: true,
          extras: {
            setup: {},
            featureType: 'whatsapp_business_app_onboarding',
            sessionInfoVersion: '3',
          },
        }
      );
    } catch {
      fail();
    }
  });
}
